const CATEGORY_LABELS = {
  material: 'Material',
  weight: 'Weight',
  color: 'Color',
  attribute: 'Style',
  other: 'Other'
};

const EMPTY_CATEGORIES = {
  material: [],
  weight: [],
  color: [],
  attribute: [],
  other: []
};

function formatFabricTagLabel(tag) {
  const dashed = String(tag || '').match(/^(\d+)-(\d+)oz$/);
  if (dashed) return `${dashed[1]}.${dashed[2]}oz`;
  return tag;
}

function normalizeCategories(categories) {
  const normalized = {
    material: categories?.material || [],
    weight: categories?.weight || [],
    color: categories?.color || [],
    attribute: categories?.attribute || [],
    other: categories?.other || []
  };
  Object.keys(normalized).forEach((key) => {
    normalized[key] = normalized[key].map(formatFabricTagLabel);
  });
  return normalized;
}

function getActiveCategoryFilters(categoryFilters) {
  return Object.values(categoryFilters).filter(Boolean);
}

export {
  CATEGORY_LABELS,
  EMPTY_CATEGORIES,
  normalizeCategories,
  getActiveCategoryFilters,
  formatFabricTagLabel
};
